import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Animations {
    constructor() {
        this.animationMainview();
    }

    animationMainview(){

        const mainview = document.querySelector('.mainview__bg');

        if(!mainview) {
            return;
        }

        gsap.timeline({
            scrollTrigger: {
                trigger: mainview,
                start: "top 0%",
                scrub: true,
                markers: false,
            }})
            .fromTo(mainview, {
                yPercent: 0
            }, {
                yPercent: 15,
            });
    }


}

export default Animations;
